// removed by extract-text-webpack-plugin
module.exports = {"pages":"magazines_1AKOh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App.scss
// module id = 507
// module chunks = 1